module.exports = __webpack_public_path__ + "static/media/whychoose_4.769470c9.jpg";